<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M5 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.414A2 2 0 0 0 20.414 7L15 1.586A2 2 0 0 0 13.586 1H5zm0 2h8v4a2 2 0 0 0 2 2h4v10H5V4zm10 .414L18.586 8H15V4.414zM7 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1zm1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8z"
    />
  </svg>
</template>

<style scoped>
svg {
  transition: color 0.3s ease-in-out;
}
</style>
